var changeQueryString = function (searchString, documentTitle){
    documentTitle = typeof documentTitle !== 'undefined' ? documentTitle : document.title;
    var urlSplit=( window.location.href ).split( "?" );
    var obj = {};
    if (searchString) {
        obj = { Title: documentTitle, Url: urlSplit[0] + '?' + searchString };
    } else {
        obj = { Title: documentTitle, Url: urlSplit[0]};
    }
    history.pushState(obj, obj.Title, obj.Url);
};
